import { CommonConstants } from "../../common/constants/common-constants";
import { IAPIResponse, IHTTPResponse } from "../../common/models/httpModels";
import { HTTPService } from "../../common/services/httpService";
import { IVideoLessionFile, IVideoLessionFileDeleteRequest, IVideoLessionFileUploadRequest } from "./VideoLessionFileModels";


const httpService = new HTTPService();
const fileUpload = (files: File[], fileRequest: IVideoLessionFileUploadRequest): Promise<IHTTPResponse<IAPIResponse<any>>> => {
    const url = `${CommonConstants.BaseAddress}${CommonConstants.ApiConstants.VideoLessionFileUpload}`;
    const formData = new FormData();
    files.forEach((file) => { formData.append('files', file) });
    formData.append('subjectId', fileRequest.subjectId.toString());
    formData.append('filterId', fileRequest.filterId.toString());

    return httpService.fileUpload(url, formData);
};

const getFiles = (filterId: number): Promise<IHTTPResponse<IAPIResponse<IVideoLessionFile>>> => {
    const url = `${CommonConstants.BaseAddress}${CommonConstants.ApiConstants.VideoLessionFiles}/${filterId}`;
    return httpService.get(url);
}

const deleteFile = (deleteFileRequest: IVideoLessionFileDeleteRequest): Promise<IHTTPResponse<IAPIResponse<IVideoLessionFile>>> => {

    const url = `${CommonConstants.BaseAddress}${CommonConstants.ApiConstants.VideoLessionDeleteFile}`;

    return httpService.post(url, deleteFileRequest);
}

const getFileDownloadUrl = (fileId: number): string => {

    const url = `${CommonConstants.BaseAddress}${CommonConstants.ApiConstants.VideoLessionDownloadFile}/${fileId}`;

    return url;
}

const VideoLessionFileService = {
    fileUpload,
    getFiles,
    deleteFile,
    getFileDownloadUrl
};

export default VideoLessionFileService;